module.exports = __webpack_public_path__ + "img/single-category.3458fff0.png";